// export const baseURLProd='https://inmortaltechnologies.com/mbaguruApp/api/web/'
export const baseURLProd="https://newapp.mbaguru.in/api/web/"
